<template>
  <div class="main">
    <c-panel title="Ponto da rota" titleIcon="fas fa-map-marker-alt">
      <form-ponto :paramId="id" @onSubmitPonto="afterSubmit"></form-ponto>
    </c-panel>
  </div>
</template>

<script>
import formPonto from "./form"

export default {
  components: { formPonto },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/ponto') }
  }
}
</script>

